var map = {
	"./cn": 37090,
	"./cn.json": 37090,
	"./en": 54560,
	"./en.json": 54560,
	"./es": 24951,
	"./es.json": 24951,
	"./locales": 69841,
	"./locales.js": 69841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45772;